import React from "react"
import RichText from "components/rich-text"
// import styles from "./item.module.scss"

const Item = ({ richTextSimple }) => {
  return <RichText text={richTextSimple} />
}

export default Item